import SimilarityScore from '../../similarity-score/SimilarityScore';
import {ReactComponent as GenerateIcon} from '../../../../../../../assets/images/icon-ai-button-default.svg';
import {ReactComponent as ViewIcon} from '../../../../../../../assets/images/summary.svg';
import {ReactComponent as GeneratingIcon} from '../../../../../../../assets/images/icon-left.svg';
import {Box, Typography} from '@mui/material';
import './ViewDocsDataGrid.scss';
import {t} from 'i18next';
import {UserRights} from '../../../../../../../api/types/user.type';

export const Columns = (
  toggleExpand: (id: number) => void,
  startGenerating: (id: number, docId: string) => void,
  expandedRows: Set<number>,
  generatingRows: number[],
  wrap: any,
  handleLinkClick: (documentId: number, docId: string) => void,
  userRights: UserRights
) => [
  {
    field: 'docId',
    headerName: t('ai.investigate.viewInDocListGrid.docID'),
    flex: 1,
    minWidth: 524,
    sortable: true,
    renderCell: (params: any) => (
      <Box className="ai-summary-column">
        <Typography
          className="typo-text body3_size"
          onClick={() =>
            handleLinkClick(params.row.documentId, params.row.docId)
          }
          data-testid={`docId-${params.id}`}
          sx={{
            '&:hover': {cursor: 'pointer'},
          }}
        >
          {params.row.docId}
        </Typography>
      </Box>
    ),
  },

  {
    field: 'summary',
    headerName: t('ai.investigate.viewInDocListGrid.aiSummary'),
    flex: 1,
    minWidth: 162,
    sortable: false,
    renderCell: (params: any) => {
      const {summary, documentId, docId} = params.row;

      const isExpanded = expandedRows.has(documentId);
      const isGenerating = generatingRows.includes(documentId);

      let label = summary;
      let Icon = GenerateIcon;

      // Make summary check robust
      if (isGenerating) {
        label = t('ai.investigate.viewInDocListGrid.generating');
        Icon = GeneratingIcon;
      } else if (summary && summary.length > 0 && isExpanded) {
        label = t('ai.investigate.viewInDocListGrid.hide');
        Icon = ViewIcon;
      } else if (summary && summary.length > 0 && !isExpanded) {
        label = t('ai.investigate.viewInDocListGrid.view');
        Icon = ViewIcon;
      } else if (!summary || summary.length === 0) {
        if (!userRights.canAIBatchSummarize) return null;

        label = t('ai.investigate.viewInDocListGrid.generate');
        Icon = GenerateIcon;
      }

      const handleClick = () => {
        label === t('ai.investigate.viewInDocListGrid.generate')
          ? startGenerating(documentId, docId)
          : toggleExpand(documentId);
      };

      return (
        <Box
          className="ai-summary-column"
          onClick={handleClick}
          sx={{'&:hover': {cursor: 'pointer'}}}
          data-testid={`label-${params.id}`}
        >
          <Icon className={isGenerating ? 'generating-icon' : ''} />
          <Typography
            className="typo-text label2_size"
            data-testid={`text-label-${params.id}`}
          >
            {label}
          </Typography>
        </Box>
      );
    },
  },

  {
    field: 'similarityScore',
    headerName: t('ai.investigate.viewInDocListGrid.similarityScore'),
    flex: 1,
    minWidth: 162,
    sortable: true,
    renderCell: (params: any) => {
      const score = params.row?.similarityScore ?? 0;
      const formatted = score.toString().replace(/^0\./, '.');

      return (
        <SimilarityScore score={score} dataTestId={params?.id ?? '0'}>
          <Typography
            className="typo-text body3_size"
            data-testid={`Sim-scrore-cell-${params?.id ?? '0'}`}
          >
            {formatted}
          </Typography>
        </SimilarityScore>
      );
    },
  },
];
